// src/Components/Shared/NavigationOverlay.jsx
import { Spin } from "antd";
import { useNavigation } from "../Context/NavigationContext";

const NavigationOverlay = () => {
  const { isPending } = useNavigation();

  if (!isPending) return null;

  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center bg-white/50 backdrop-blur-sm">
      <Spin size="large" />
    </div>
  );
};

export default NavigationOverlay;